// Vue
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Components
import { Container } from "../../container/Container";
import { Icon } from "../../icon/Icon";

// Libraries
import { HttpService } from "../../../../services/HttpService";
import { Row } from "../../row/Row";
import { Col } from "../../col/Col";
import { Checkbox } from "../../checkbox/Checkbox";
import { P } from "../../p/P";
import { Button } from "../../button/Button";
import { getCookie, setCookie } from "../../../../utils/cookie";

@Component({
  components: {
    Container,
    Icon,
    MgsRow: Row,
    MgsCol: Col,
    MgsCheckbox: Checkbox,
    MgsButton: Button,
    MgsP: P,
  },
  mixins: [template],
})
export class CookieSettings extends Vue {
  @Prop({ default: "en" })
  public language!: string;

  @Prop({ default: true })
  public showHeader!: boolean;

  @Prop({ default: true })
  public showFooter!: boolean;

  @Prop({ default: false })
  public isAlwaysExpanded!: boolean;

  private readonly http: HttpService = HttpService.instance;

  private readonly allMarketingCookies: string[] = ["youtube"];

  public isMoreInfo: boolean = false;
  public isMatomoActive: boolean = false;

  public isMarketingActive: boolean = false;
  public isYoutubeActive: boolean = false;

  public marketingCookies: string[] = [];

  public toggleMoreInfo() {
    this.isMoreInfo = !this.isMoreInfo;
  }

  get isExpanded() {
    return this.isMoreInfo || this.isAlwaysExpanded;
  }

  public mounted() {
    this.computeIsMatomoActive();

    this.marketingCookies = getCookie("marketing-cookies") ? JSON.parse(getCookie("marketing-cookies")) : [];
  }

  public handleCookieAccept(matomoAccepted: boolean) {
    // @ts-ignore
    if (window._paq) {
      if (matomoAccepted) {
        // @ts-ignore
        window._paq.push(["rememberConsentGiven"]);
        // @ts-ignore
        window._paq.push(["forgetUserOptOut"]);
      } else {
        // @ts-ignore
        window._paq.push(["optUserOut"]);
      }
    }
    this.computeIsMatomoActive();
    this.updateTrackingStatus(matomoAccepted);

    setCookie("marketing-cookies", JSON.stringify(this.marketingCookies));

    this.$emit("agreed");

    window.location.reload();
  }

  public handleSelectChecked() {
    this.handleCookieAccept(this.isMatomoActive);
  }

  public handleSelectAll() {
    this.isMatomoActive = true;
    this.setMarketingActive(true);
    setTimeout(() => {
      this.handleCookieAccept(true);
    }, 300);
  }

  public async updateTrackingStatus(trackingEnabled: boolean) {
    try {
      let queryUrl = `${APP_API_URL}auth/v2.0/${this.language}/update_tracking_status`;
      const response = await this.http.post<Object>(queryUrl, {
        status: trackingEnabled,
      });

      return response.body!;
    } catch (e: any) {
      if (e.status == 403) {
        return e.body!;
      } else {
        throw e;
      }
    }
  }

  public parseCookieLinkText(text: string, start: string, end: string) {
    let startPos = text.indexOf(start) > -1 ? text.indexOf(start) + start.length : 0;
    let endPos = text.indexOf(end) > -1 ? text.indexOf(end) - startPos : text.length - startPos;

    return text.substr(startPos, endPos);
  }

  public handleFooterClick(itemName: string) {
    this.$emit("openPolicy", itemName);
  }

  private computeIsMatomoActive() {
    let self = this;
    // @ts-ignore
    if (window._paq) {
      // @ts-ignore
      window._paq.push([
        function () {
          // @ts-ignore
          self.isMatomoActive = !this.isUserOptedOut();
        },
      ]);
    }
  }

  public setMarketingActive(value: boolean) {
    if (value) {
      this.marketingCookies = [...this.allMarketingCookies];
    } else {
      this.marketingCookies = [];
    }
  }

  public setYoutubeActive(value: boolean) {
    if (value) {
      this.marketingCookies.push("youtube");
    } else {
      const index = this.marketingCookies.findIndex((cookie) => cookie === "youtube");
      if (index !== -1) {
        this.marketingCookies.splice(index, 1);
      }
    }
  }

  @Watch("marketingCookies", { deep: true })
  public watchmarketingCookies(value: string[]) {
    this.isMarketingActive = this.allMarketingCookies.every((cookie) => this.marketingCookies.includes(cookie));
    this.isYoutubeActive = value.includes("youtube");
  }
}
